module.exports = __webpack_public_path__ + "img/logo.e1701c47.png";